import { Vehicle, VehicleBatch, VehicleEvent, VehicleInsurance } from '@models';

export interface VehicleState {
  vehicles: Vehicle[];
  batches: VehicleBatch[];
  vehicleEvents: VehicleEvent[];
  vehicleInsurances: VehicleInsurance[];
  fetchedAt: Date | null;
  eventsFetchedAt: Date | null;
  batchesFetchedAt: Date | null;
  vehicleInsurancesFetchedAt: { [vehicleId: string]: Date };
}

export const initialVehicleState: VehicleState = {
  vehicles: [],
  batches: [],
  vehicleEvents: [],
  vehicleInsurances: [],
  fetchedAt: null,
  eventsFetchedAt: null,
  batchesFetchedAt: null,
  vehicleInsurancesFetchedAt: {},
};
